import { useContext } from 'react';
import { NotificationContext } from '../context';

export const useNotify = () => {
  const context = useContext(NotificationContext);
  if (!context) throw new Error('There is no notify provider');
  return context;
};
